import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	header: {
		id: 'directories.boards-v2.main.content.error.header',
		defaultMessage: "We couldn't load your boards",
		description:
			'Heading for the error state (error screen) which is displayed for users on boards page in case boards fetching ended up with an error',
	},
	description: {
		id: 'directories.boards-v2.main.content.error.description',
		defaultMessage:
			'Give it another try. If you run into more trouble, contact your admin for help.',
		description:
			'Message for the error state (error screen) which is displayed for users on boards page in case boards fetching ended up with an error',
	},
});
export default messages;
